import {
    CategoryFocusBox,
    FocusNews,
    FocusNewsImageLink,
    FocusNewsImage,
    FocusNewsBody,
    FocusNewsCategory,
    FocusNewsTitle,
    FocusNewsDesc,
    FocusNewsLink,
    FocusNewsRelative,
    RelativeWrap,
    CategoryFocusList,
    CategoryFocusItem,
    CategoryFocusImageLink,
    CategoryFocusImage,
    CategoryFocusTitle
} from './categoryFocusElements'
import queryString from 'query-string';
import { useState, useEffect } from 'react'
import newsApi from '../../api/newsApi'
import {BorderLine} from '../../pages/home/homeElements'
import Grid from '@material-ui/core/Grid';


const CategoryFocus = ({category}) => {
    const [news, setNews] = useState({})
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const getNews = async () => {
            const response = await newsApi.getNewsFromCategory({category, _limit: 8})
            setNews(response.news)
            setLoading(false)
        }

        getNews()
    },[category])



    if(loading) return <></>

    return (
        <CategoryFocusBox>
            <FocusNews>
                <FocusNewsImageLink title={news[0].title} to={`/news/${news[0]._id}`}>
                    <FocusNewsImage src={news[0].image} alt={news[0].title} />
                </FocusNewsImageLink>
                <FocusNewsBody>
                    <FocusNewsCategory className='hide-on-mobile' title={category} to={`/category/news?${queryString.stringify({category})}`}>{category}</FocusNewsCategory>
                    <FocusNewsTitle title={news[0].title} to={`/news/${news[0]._id}`}>{news[0].title}</FocusNewsTitle>
                    <FocusNewsDesc>{news[0].description}</FocusNewsDesc>
                    <FocusNewsRelative>
                        <RelativeWrap>
                            <FocusNewsLink title={news[1].title} to={`/news/${news[1]._id}`}>{news[1].title}</FocusNewsLink>
                        </RelativeWrap>
                        <RelativeWrap>
                            <FocusNewsLink title={news[2].title} to={`/news/${news[2]._id}`}>{news[2].title}</FocusNewsLink>
                        </RelativeWrap>
                    </FocusNewsRelative>
                </FocusNewsBody>
            </FocusNews>
            <BorderLine style={{margin: '10px 0'}} />
                <CategoryFocusList>
                    <Grid container spacing={1}>
                        {news.slice(3).map((news, index) => (
                            <Grid key={index} item sm={12} md>
                                <CategoryFocusItem>
                                    <CategoryFocusImageLink title={news.title} to={`/news/${news._id}`}>
                                        <CategoryFocusImage alt={news.title} src={news.image} />
                                    </CategoryFocusImageLink>
                                    <CategoryFocusTitle to={`/news/${news._id}`}>{news.title}</CategoryFocusTitle>
                                </CategoryFocusItem>
                            </Grid>
                        ))}
                    </Grid>
                </CategoryFocusList>
        </CategoryFocusBox>
    )
}

export default CategoryFocus
